import axios from "axios";
import { useState, useEffect } from "react";
import { Box, FormControl, TextField } from "@mui/material";
import Combobox from "../../../components/common/Combobox";
import { PopperFullWidth, getInputLabelProps } from "../../../common/appStyles";
import useGlobalContext from "../../../hooks/useGlobalContext";
import localize from "../../../common/localize";
import { MAXIMUM_CHARACTERS_FOR_DESCRIPTION_OR_OBSERVATION } from "../../../common/utils";

export default function PreOrderStatusAssignment({
  eventStatus,
  setEventStatus,
  observation,
  setObservation,
}) {
  const [eventStatuses, setEventStatuses] = useState();
  const { STATUS_ENDPOINT, config } = useGlobalContext();
  const [descriptionCount, setDescriptionCount] = useState(0);
  const maximumCharactersForDescription = MAXIMUM_CHARACTERS_FOR_DESCRIPTION_OR_OBSERVATION;

  const getEventStatus = async () => {
    const requestConfig = {
      ...config,
    };
    requestConfig.headers.pagination = -1;
    const data = await axios.get(`${STATUS_ENDPOINT}`, requestConfig);

    if (data?.data?.Data?.length > 0) {
      setEventStatuses(data?.data?.Data);
    }
  };

  useEffect(() => {
    getEventStatus();
  }, []);

  useEffect(() => {
    if (observation) {
      setDescriptionCount(observation.length);
    }
  }, [observation]);

  const handleObservatinoChange = (e) => {
    setObservation(e.target.value);
  };

  const handleEventStatusChange = (value) => {
    setEventStatus(value);
  };

  return (
    <Box sx={{ width: "100%", display: "flex", flexDirection: "column" }}>
      <div className="mt-2" style={{ width: "100%", marginBottom: "10px" }}>
        <FormControl required fullWidth>
          <Combobox
            disabled={!(eventStatuses?.length > 0)}
            id="StatusId"
            fieldLabel={localize.status}
            fieldOptions={eventStatuses ?? []}
            fieldValue={eventStatus}
            popperFullWidth={PopperFullWidth}
            handleValueChange={handleEventStatusChange}
          />
        </FormControl>
      </div>

      <FormControl required fullWidth>
        <TextField
          InputLabelProps={getInputLabelProps()}
          inputProps={{
            style: {
              fontSize: "0.8em",
            },
            maxLength: maximumCharactersForDescription,
          }}
          size="small"
          fullWidth
          multiline
          rows={6}
          id="outlined-basic"
          name="Observation"
          label={localize.observations}
          variant="outlined"
          onChange={handleObservatinoChange}
          value={observation}
          helperText={`${descriptionCount}/${maximumCharactersForDescription}`}
        />
      </FormControl>
    </Box>
  );
}
